import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//#region DATERPICKER
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  Day
} from "@material-ui/pickers";
import "date-fns";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';

//#endregion

//#region CSS
const useStyles = makeStyles(theme => ({
  renderDay: {
    background: "red",
    color: "white",
    borderRadius: "50%",
    "&:hover": {
      background: '#8dbb35'
    }
  },
  message: {
    color: " rgba(0, 0, 0, 0.54)",
    margin: " 0",
    fontSize: " 0.75rem",
    marginTop: " 3px",
    textAlign: " left",
    fontWeight: " 400",
    lineHeight: " 1.66",
    letterSpacing: " 0.03333em"
  }
}));
//#endregion

export default function DatePicker({
  label,
  value,
  onChange,
  onBlur,
  onKeyPress,
  disabled,
  required,
  error,
  className,
  datesToEnabled,
  datesToRender,
  isSemanal
}) {
  const classes = useStyles();
  const [daysEnabled, setDaysEnabled] = useState([]);
  const [errorDP, setErrorDP] = useState(error);
  const [daysRendered, setDaysRendered] = useState([]);

  //#region Functions
  const dateParseTime = dates => {
    if (dates) {
      return dates.map(d => {
        let time = d.getTime();
        return time;
      });
    } else {
      return [];
    }
  }
  //#endregion

  //#region Handle
  const onChangeDP = date => {
    if (date) {
      let dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());

      if (dateWithoutTime) {
        if (daysEnabled.length !== 0) {
          if (daysEnabled.includes(dateWithoutTime.getTime())) {
            setErrorDP(false);
            onChange(dateWithoutTime);
          } else {
            setErrorDP(true);
            onChange(null);
          }
        } else {
          if (!isNaN(dateWithoutTime.getTime())) {
            onChange(dateWithoutTime);
            setErrorDP(false);
          } else {
            setErrorDP(true);
          }
        }
      } else {
        setErrorDP(true);
      }
    }
    else {
      onChange(null);
    }
  }
  //#endregion

  //#region Display
  const disableDays = day => {
    if (day.getDate() === new Date(value).getDate()) {
      return false;
    }
    if (daysEnabled.length !== 0) {
      return !daysEnabled.includes(day.getTime());
    }
    return false;
  }

  function disableAllDayMinusMonday(date) {
    return date.getDay() !== 1;
  }

  const renderDays = (date, selectedDate, isInCurrentMonth, dayComponent) => {
    const isRendered = daysRendered.includes(date.getTime());

    return <div className={isRendered && isInCurrentMonth && !dayComponent.props.selected ? classes.renderDay : {}}>
      <Day
        children={dayComponent.props.children}
        current={dayComponent.props.current}
        disabled={daysEnabled.length !== 0 ? !daysEnabled.includes(date.getTime()) : dayComponent.props.disabled}
        hidden={dayComponent.props.hidden}
        selected={dayComponent.props.selected}
      /></div>;
  }
  //#endregion

  useEffect(() => {
    setDaysEnabled(dateParseTime(datesToEnabled));
    setDaysRendered(dateParseTime(datesToRender));
  }, [datesToEnabled, datesToRender]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
      <KeyboardDatePicker
        fullWidth
        //variant="inline"
        format="dd/MM/yyyy"
        error={errorDP}
        //autoOk
        required={required}
        disabled={disabled}
        className={className}
        id="date-picker-inlined"
        label={label}
        invalidDateMessage="Formato incorrecto"
        minDateMessage="Fecha no válida"
        maxDateMessage="Fecha no válida"
        value={value}
        onChange={onChangeDP}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        KeyboardButtonProps={{
          "aria-label": "change date"
        }}
        minDate={new Date("1900-01-02")}
        shouldDisableDate={isSemanal ? disableAllDayMinusMonday : disableDays}
        renderDay={renderDays}
      />
      {errorDP ? <Typography
        className={classes.message}
      >
        Fecha no válida
      </Typography> : null}
    </MuiPickersUtilsProvider>
  );
}

DatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool
};
